/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import React, { useCallback, useEffect, useState ,useRef} from 'react'
import './App.css';
import { AnimatePresence, motion } from 'framer-motion';
import 'tw-elements';
import './index.css';
import { useDispatch, useSelector } from 'react-redux'
import GlobalContext from './components/Context/GloablContext';
import Toast from './components/Toast';
import NavigationRoutes from './routes';
import { handleSystemConfig, resetState } from './redux/systemConfigSlice'
import { dataService } from './services/data.services';
import { userService } from './services/user.services';
import refreshIdToken from './CommonMethods/RefreshIdFunction';
import { AwsRum } from 'aws-rum-web';
import { stage } from './config/index'
import { awsConfig } from './config/aws-export';
import { Amplify } from 'aws-amplify';
import { websocketURL } from '../src/config/index'
import { handleEditMessageSent,handleTargetUserEditId } from './redux/systemConfigSlice'
import { useNavigate } from 'react-router-dom';
import { clearSessionCookie } from './CommonMethods/authSession';
import { fetchImageAsBlob, getPDFImage, storePDFImage } from './components/HelpGuideModal/InedxDb';
import { setupLogoutListener, setupSessionConfirmedListener, restoreAuthFromLocalStorage, clearAuthData, broadcastLogout, broadcastForcedLogout } from './CommonMethods/AuthSync';
import { logout } from './pages/auth/authSlice';
// import { fetchFeatureFlags } from './CommonMethods/appConfig';

if (process.env.REACT_APP_STAGE === 'prod') {
    try {
        const config = {
            sessionSampleRate: 1 ,
            identityPoolId: "us-east-1:e471239d-aae8-4a50-ae67-3d92f504f63a" ,
            endpoint: "https://dataplane.rum.us-east-1.amazonaws.com" ,
            telemetries: ["performance","errors","http"] ,
            allowCookies: true ,
            enableXRay: false ,
            signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
        };

        const APPLICATION_ID = '78002ff2-f0e1-4777-9d00-47c5bfc1250f';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'us-east-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );console.log("awsRum")
    } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}

Amplify.configure(awsConfig)

function App(props) {
    const navigationPath = NavigationRoutes(props)
    const editingUserIdRef = useRef('');
    const navigate = useNavigate();
    const [Toastmessage, setToastmessage] = useState('');
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [ToastWarnmessage, setToastWarnmessage] = useState('')
    const restrict = useSelector(state => state?.systemConfigData?.restrict)
    const [isSideBar, setIsSideBar] = useState(restrict);
    const [UpdateCall, setUpdateCall] = useState(false)
    const [systemConfigDateformat, setSystemConfigDateformat] = useState('')
    const [getData, setGetData] = useState()
    const dispatch = useDispatch()
    const [editSocket,setEditSocket] = useState(false)
    const editingUserId = useSelector(state=>state?.systemConfigData?.editingUserId)
    const [userEditId,setUserEditId] = useState('')
    const [isAdvancedSearchOpen,setIsAdvancedSearchOpen]=useState(false)


    const [globalVariables, setGlobalVariables] = useState({
        "date_format": "",
        "country_code": "",
        "max_file_size": "",
        "email_addr": "",
        "session_timeout": "",
        "public_encryp_key": "",
        "browser_trust_duration": "",
        "temp_pass_duration": "",
        "recent_otp_durn": "",
        "max_failed_attempts": "",
        "otp_validity_durn": ""
    })

    const [vital_information, setVitalInfo] = useState({
        "blood_glucose": " ",
        "blood_pressure": " ",
        "temperature": " ",
        "SP02": " ",
        "pulse": " ",
        "weight": " ",
        "height": " "
    })

    const [patientID, setPatientID] = useState('')


    const fetchSystemConfigData = useCallback(async () => {
        // setLoading(true )
        let response
        response = await dataService.systemConfigDataFromAdmin();
        if (response.error === false) {
            setGetData(response.data.data)
            dispatch(handleSystemConfig(response.data))
            const Getdata = response.data
            setSystemConfigDateformat((prev) => ({
                ...prev,
                "date_format": response?.data?.global_variables.date_format,
                "blood_glucose": response?.data?.vital_information?.blood_glucose,
                "blood_pressure": response?.data?.vital_information?.blood_pressure,
                "temperature": response?.data?.vital_information?.temperature,
                "SP02": response?.data?.vital_information?.SP02,
                "pulse": response?.data?.vital_information?.pulse,
                "weight": response?.data?.vital_information?.weight,
                "height": response?.data?.vital_information?.height,
            }))
            setGlobalVariables((prev) => ({
                ...prev,
                "date_format": Getdata?.global_variables?.date_format,
                "country_code": Getdata?.global_variables?.country_code,
                "max_file_size": Getdata?.global_variables?.maximum_file_size,
                "email_addr": Getdata?.global_variables?.email_address,
                "session_timeout": Getdata?.global_variables?.session_timeout,
                "public_encryp_key": Getdata?.global_variables?.public_encryption_key,
                "browser_trust_duration": Getdata?.global_variables?.browser_trust_duration,
                "temp_pass_duration": Getdata?.global_variables?.temporary_password_expiry_duration,
                "recent_otp_durn": Getdata?.global_variables?.resend_otp_duration,
                "max_failed_attempts": Getdata?.global_variables?.max_failed_login_attempts,
                "otp_validity_durn": Getdata?.global_variables?.otp_validity_duration
            }))
            setVitalInfo((prev) => ({
                ...prev,
                "blood_glucose": Getdata?.vital_information?.blood_glucose,
                "blood_pressure": Getdata?.vital_information?.blood_pressure,
                "temperature": Getdata?.vital_information?.temperature,
                "SP02": Getdata?.vital_information?.SP02,
                "pulse": Getdata?.vital_information?.pulse,
                "weight": Getdata?.vital_information?.weight,
                "height": Getdata?.vital_information?.height,

            }))
        }

    }, [])


    // Define the handleRefreshToken function
    const handleRefreshToken = async () => {
        if (sessionStorage.getItem('IdToken')) {
            refreshIdToken()
        }
    };


    const sendMessageToStartEditing = (data,isReconnect,ws) => {
        
        const startEditingAction = { action: 'startEditing', target: data ==='' ? editingUserId :data , user:sessionStorage.getItem('email') };
        
        if(isReconnect!==undefined && isReconnect==='reconnect'){

            ws.send(JSON.stringify(startEditingAction))
            setUserEditId(data)            
            dispatch(handleEditMessageSent(true))
        }else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1)) {
            
            editSocket.send(JSON.stringify(startEditingAction));
            setUserEditId(data)
            dispatch(handleEditMessageSent(true))
        }else if(editSocket?.readyState===3){
            WebSocketConnection('start',data)
        }
    };

    const sendMessageToStopEditing = (data) => {
       
        let stopEditingAction = { action: 'stopEditing', target: userEditId==='' ? ((data===undefined || data==='') ? editingUserId : data): userEditId };
        if(stopEditingAction.target === '' || stopEditingAction.action === undefined) {
            stopEditingAction['target'] = data || userEditId || editingUserId || patientID
        }
        
        if((!editSocket||editSocket?.readyState!==1)&&window?.websocket?.readyState===1&&(stopEditingAction?.target!==''&&stopEditingAction?.target!==undefined)&&(userEditId!==''||userEditId!==undefined)){
            window?.websocket?.send(JSON.stringify(stopEditingAction))
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))
        }
        else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1)&&(userEditId!==''||userEditId!==undefined||data!==undefined)) {
            editSocket?.send(JSON.stringify(stopEditingAction));
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))

        }else if(editSocket?.readyState===3){
            console.error('WebSocket connection is not open');
            //WebSocketConnection('stop',userEditId===''?data:userEditId)
        }
    }
    const WebSocketConnection = (startOrStop,targetId) =>{
        dispatch(handleEditMessageSent(false))
        // Close the socket we are replacing: the backend counts every live
        // connection as an active session.
        const previousSocket = window.websocket;
        if (previousSocket) {
            // Detach handlers first, or close() re-enters via the reconnect below.
            previousSocket.onmessage = null;
            previousSocket.onclose = null;
            previousSocket.onerror = null;
            if (previousSocket.readyState === 0 || previousSocket.readyState === 1) {
                previousSocket.close();
            }
        }
        const ws = new WebSocket(`${websocketURL}?user=${encodeURIComponent(sessionStorage.getItem('email')) }`);
        window.websocket = ws
        
        ws.onopen = () => {
            
            setEditSocket(ws)
            if(startOrStop!==undefined&&startOrStop==='start'){
                sendMessageToStartEditing(targetId===''?editingUserId:targetId,'reconnect',ws )
                //addpersist logic here to get target userid nd send message
            }else if(startOrStop!==undefined&&startOrStop==='stop'){
                sendMessageToStopEditing(targetId===''?editingUserId:targetId)
            } else {
                dispatch(handleEditMessageSent(false))
            }
            // You can add further logic here, like informing the server about the edit screen access.
        };
        ws.onclose = () => {
            const editedUserId = editingUserIdRef.current;
            if(sessionStorage.getItem('IdToken')){
                editedUserId!==''? WebSocketConnection('start',editedUserId): WebSocketConnection(); // 3 seconds delay, adjust as needed
            }
        }
        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            // Attempt to reconnect after a delay
            setTimeout(WebSocketConnection, 3000); // 3 seconds delay, adjust as needed
        };
    }

    // Close the socket before the page unloads or is frozen into the back/forward
    // cache. A stranded connection reads as an active session and blocks the next
    // login. Reopen it if the page comes back from that cache.
    useEffect(() => {
        const closeSocketOnPageHide = () => {
            const ws = window.websocket;
            if (!ws) { return; }
            ws.onmessage = null;
            ws.onclose = null;
            ws.onerror = null;
            if (ws.readyState === 0 || ws.readyState === 1) {
                ws.close();
            }
        };
        const reopenSocketOnRestore = (event) => {
            if (event.persisted && sessionStorage.getItem('IdToken')) {
                WebSocketConnection();
            }
        };
        window.addEventListener('pagehide', closeSocketOnPageHide);
        window.addEventListener('pageshow', reopenSocketOnRestore);
        return () => {
            window.removeEventListener('pagehide', closeSocketOnPageHide);
            window.removeEventListener('pageshow', reopenSocketOnRestore);
        };
    }, []);
    
  

    // Optionally, you can clear the interval if needed (for example, when the component unmounts)
    // clearInterval(intervalId);
    useEffect(() => {
        // Duplicated tabs inherit sessionStorage with staged tokens and the pending flag.
        // Skip session restore and WebSocket setup entirely to prevent authenticated routes.
        if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
            fetchSystemConfigData()
            return;
        }

        // Restore auth from localStorage if sessionStorage is empty (new tab scenario)
        if (!sessionStorage.getItem('IdToken')) {
            const restored = restoreAuthFromLocalStorage();
            if (restored) {
                // Auth restored, trigger a re-render by updating state
                window.dispatchEvent(new Event('storage'));
            }
        }

        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
        if (sessionStorage.getItem('IdToken')) {
            refreshIdToken()
            WebSocketConnection()
        }
        fetchSystemConfigData()
        // fetchFeatureFlags()
    }, [])

    useEffect(()=>{
        editingUserIdRef.current = editingUserId;
    },[editingUserId])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) 
                    return; // Prevent multiple logout calls
                
                const message = event.data;
                
                if (message === "logout") {
                    // This tab is mid-confirmation of a duplicate session — skip forced logout.
                    if (sessionStorage.getItem('duplicateTabCloseInProgress') === 'true') return;
                    hasLoggedOut = true;
                    
                    // This happens when server forces logout (e.g., duplicate session)
                    const isPasswordUpdateLogout = localStorage.getItem('passwordUpdateLogout') === 'true';
                    
                    // Close WebSocket connections
                    if (editSocket && (editSocket.readyState === 1 || editSocket.readyState === 0)) {
                        editSocket.close();
                    }
                    if (window.websocket && (window.websocket.readyState === 1 || window.websocket.readyState === 0)) {
                        window.websocket.close();
                    }
                    
                    // Call backend duplicate logout API
                    await userService.DuplicateLogout();
                    clearSessionCookie();
                    
                    // Preserve browser trust token and LogoutfromAllTabs
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    
                    // Clear auth session
                    clearAuthData();
                    
                    // Restore preserved values
                    if (arcm_trust_browser_token) {
                        localStorage.setItem("arcm_trust_browser_token", arcm_trust_browser_token);
                    }
                    if (LogoutfromAllTabs) {
                        localStorage.setItem("LogoutfromAllTabs", LogoutfromAllTabs);
                    }
                    
                    // Broadcast forced logout to other tabs (duplicate session termination)
                    // Use broadcastForcedLogout() so sibling old-session tabs show
                    // "another login session" toast instead of "logout in another tab"
                    broadcastForcedLogout();

                    // Set flag for this tab's toast after reload
                    if (!isPasswordUpdateLogout) {
                        // This is a duplicate session termination (new login from another device/browser)
                        sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                        window.location.reload(); // Full page reload
                        return;
                    }
                    
                    // Handle password update case
                    const passwordUpdateToast = localStorage.getItem('passwordUpdateSuccessToast');
                    if (passwordUpdateToast) {
                        localStorage.setItem('showLogoutToast', passwordUpdateToast);
                        localStorage.removeItem('passwordUpdateSuccessToast');
                    }
                    window.location.reload(); // Full page reload
                }
            };
        }
    },[editSocket])

    // Set up cross-tab logout listener
    useEffect(() => {
        const handleCrossTabLogout = (logoutType) => {
            // This handler ONLY runs in OTHER tabs (Tab B, C, D...)
            // It NEVER runs in Tab A (the initiating tab)

            // This tab has a pending duplicate session decision — ignore stale logout broadcasts.
            if (sessionStorage.getItem('duplicate_session_pending') === 'true') return;

            // Check if this is a password update logout
            const isPasswordUpdateLogout = localStorage.getItem('passwordUpdateLogout') === 'true';
            const passwordUpdateToast = localStorage.getItem('passwordUpdateSuccessToast');
            const showDuplicateSessionLogout = sessionStorage.getItem('showDuplicateSessionLogout') === 'true';

            // Clear auth session
            clearAuthData();

            // Dispatch logout action
            dispatch(logout());

            // Show toast directly (no flags needed - no page reload, so state persists)
            if (!isPasswordUpdateLogout) {
                if (logoutType === 'forced_logout' || showDuplicateSessionLogout) {
                    // This is a duplicate session termination (server-forced from another device/browser)
                    setToastErrorMessage('You have been logged out due to another login session');
                    sessionStorage.removeItem('showDuplicateSessionLogout');
                } else {
                    // Normal user-initiated logout from another tab
                    setToastErrorMessage('You have been logged out due to logout in another tab');
                }
            } else if (passwordUpdateToast) {
                // Handle password update toast differently
                setToastErrorMessage(passwordUpdateToast);
                localStorage.removeItem('passwordUpdateSuccessToast');
            }

            // Navigate to login page
            navigate('/');
        };

        const cleanup = setupLogoutListener(handleCrossTabLogout);
        return cleanup;
    }, [navigate, dispatch, setToastErrorMessage])

    // Listen for session_confirmed events from the tab that confirmed the duplicate session modal.
    // When received, clear the pending flag and reload so this tab picks up the promoted session.
    // Also reload tabs without an active session when tokens become available in localStorage
    // (e.g., another tab completed OTP and synced tokens — this tab should pick them up).
    useEffect(() => {
        const cleanup = setupSessionConfirmedListener(() => {
            // Tab was blocked waiting for duplicate session decision — clear flag and reload
            if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
                sessionStorage.removeItem('duplicate_session_pending');
                window.location.reload();
            }
            // Tab has no active session but tokens are now synced in localStorage — restore session
            else if (!sessionStorage.getItem('IdToken') && localStorage.getItem('arcm_auth_synced')) {
                window.location.reload();
            }
        });
        return cleanup;
    }, [])

    const handleClear=()=>{
        if((Toastmessage&&Toastmessage!=='')||(toastErrorMessage&&toastErrorMessage!=='')){
            setToastmessage('');
            setToastErrorMessage();
        }
    }   

    const fetchAndCacheHelpGuides = async () => {
        try {
            const apiResponse = await dataService.GetAPI('users/help-guides?getAllFiles=true'); 
            const files = apiResponse?.data?.data?.files || {};     
            for (const [fileName, fileUrl] of Object.entries(files)) {
                const pageKey = `${fileName}_page_1`;
    
                const cachedImage = await getPDFImage(pageKey);
                if (cachedImage) {
                    continue; // Skip if already cached
                }
    
                const imgBlob = await fetchImageAsBlob(fileUrl);
                if (imgBlob) {
                    await storePDFImage(pageKey, imgBlob);
                }
            }
        } catch (error) {
            console.error("Error fetching help guides:", error);
        }
    };

    return (
        <GlobalContext.Provider value={{
            setToastmessage, editSocket,WebSocketConnection,setEditSocket,sendMessageToStartEditing,sendMessageToStopEditing,setPatientID,
            Toastmessage, isSideBar, setIsSideBar, setToastErrorMessage, toastErrorMessage, UpdateCall, setUpdateCall, setToastWarnmessage, systemConfigDateformat,isAdvancedSearchOpen,setIsAdvancedSearchOpen, fetchAndCacheHelpGuides
        }}>
            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    onClick={()=>handleClear()}
                    transition={{ duration: 1 }}
                >
                    {navigationPath}
                    {Toastmessage !== '' && Toastmessage !== undefined && <Toast
                        message={Toastmessage}
                        type="success"
                        setToastmessage={setToastmessage} />}
                    {toastErrorMessage !== '' && toastErrorMessage !== undefined && <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage} />}
                    {ToastWarnmessage !== '' && ToastWarnmessage !== undefined && <Toast
                        message={ToastWarnmessage}
                        type="warn"
                        setToastmessage={setToastWarnmessage} />}
                </motion.div>
            </AnimatePresence>
        </GlobalContext.Provider>

    );
}

export default App;
